import gql from "graphql-tag";
import MediaDetailsFragment from "../fragment/MediaDetailsFragment";

export default gql`

  ${MediaDetailsFragment}

  subscription mediaUpdate($id: String!) {
    media: mediaUpdate(id: $id) {
      ...MediaDetailsFragment
    }
  }
`